/**
 * Aura Cart — passo de upsell antes do checkout.
 *
 * Intercepta o clique em finalizar compra (na gaveta e na pagina do carrinho),
 * abre um painel com uma oferta unica e so entao segue pro checkout. Recusar e
 * aceitar levam os dois ao checkout — a diferenca e o item a mais.
 *
 * Falha aberto, sempre: sem configuracao, sem variante disponivel ou com
 * qualquer erro, o botao volta a ser o botao normal do tema. Em nenhuma
 * hipotese o cliente fica preso sem conseguir finalizar.
 */
(function () {
  'use strict';

  var cfg = null;
  var raiz = null;
  var painel = null;
  var refs = {};
  var relogio = null;
  var seguindo = false;
  var jaMostrou = false;

  /* ---------------------------------------------------------------- basico */

  function lerConfig() {
    var no = document.querySelector('[data-aura-upsell-config]');
    if (!no) return null;
    try {
      return JSON.parse(no.textContent);
    } catch (e) {
      return null;
    }
  }

  function dinheiro(centavos) {
    var formato = (cfg && cfg.moneyFormat) || '${{amount}}';
    var valor = (centavos / 100).toFixed(2);
    var partes = valor.split('.');
    var inteiro = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return formato
      .replace(/\{\{\s*amount\s*\}\}/g, inteiro + '.' + partes[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, inteiro)
      .replace(/<[^>]*>/g, '')
      .replace(/(\d)\.00(?!\d)/g, '$1');
  }

  function variantesValidas() {
    return (cfg.produto.variantes || []).filter(function (v) {
      return v.disponivel;
    });
  }

  function variantePorId(id) {
    var lista = cfg.produto.variantes || [];
    for (var i = 0; i < lista.length; i++) {
      if (String(lista[i].id) === String(id)) return lista[i];
    }
    return null;
  }

  function trocarFicha(texto, variante) {
    if (!texto) return '';
    return String(texto)
      .replace(/\[preco\]/g, dinheiro(variante.preco))
      .replace(/\[discount_label\]/g, dinheiro(variante.preco))
      .replace(/\[product_title\]/g, cfg.produto.titulo);
  }

  /* ---------------------------------------------------------------- painel */

  var ICONE_FECHAR =
    '<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M1 1l16 16M17 1L1 17" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

  function montar() {
    var disponiveis = variantesValidas();
    if (!disponiveis.length) return false;

    raiz = document.createElement('div');
    raiz.id = 'aura-upsell-root';
    raiz.setAttribute('role', 'dialog');
    raiz.setAttribute('aria-modal', 'true');

    painel = document.createElement('div');
    painel.className = 'aura-upsell';
    raiz.appendChild(painel);

    painel.innerHTML =
      '<div class="aura-upsell__topo">' +
      '<button type="button" class="aura-upsell__fechar" aria-label="Close">' + ICONE_FECHAR + '</button>' +
      '</div>' +
      '<div class="aura-upsell__hero">' +
      '<p class="aura-upsell__chamada" data-chamada></p>' +
      '<span class="aura-upsell__nota"><span class="aura-upsell__estrelas">★★★★★</span>' +
      '<span data-nota></span></span>' +
      '</div>' +
      '<div class="aura-upsell__timer">' +
      '<span class="aura-upsell__timer-rotulo" data-timer-rotulo></span>' +
      '<span class="aura-upsell__timer-valor" data-timer>05:00</span>' +
      '</div>' +
      '<div class="aura-upsell__corpo">' +
      '<div class="aura-upsell__foto"><img alt="" data-foto></div>' +
      '<div class="aura-upsell__info">' +
      '<h3 class="aura-upsell__titulo" data-titulo></h3>' +
      '<p class="aura-upsell__sub" data-sub></p>' +
      '<div class="aura-upsell__precos">' +
      '<span class="aura-upsell__was-rotulo" data-was-rotulo></span>' +
      '<span class="aura-upsell__was" data-was></span>' +
      '<span class="aura-upsell__virgula">,</span>' +
      '<span class="aura-upsell__now-rotulo" data-now-rotulo></span>' +
      '<span class="aura-upsell__now" data-now></span>' +
      '</div>' +
      '<div class="aura-upsell__variante">' +
      '<label class="aura-upsell__variante-rotulo" data-variante-rotulo></label>' +
      '<select class="aura-upsell__select" data-select></select>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '<div class="aura-upsell__rodape">' +
      '<div class="aura-upsell__botoes">' +
      '<button type="button" class="aura-upsell__recusar" data-recusar></button>' +
      '<button type="button" class="aura-upsell__aceitar" data-aceitar></button>' +
      '</div>' +
      '<div class="aura-upsell__bandeiras" data-bandeiras></div>' +
      '</div>';

    document.body.appendChild(raiz);

    refs = {
      chamada: painel.querySelector('[data-chamada]'),
      nota: painel.querySelector('[data-nota]'),
      timerRotulo: painel.querySelector('[data-timer-rotulo]'),
      timer: painel.querySelector('[data-timer]'),
      foto: painel.querySelector('[data-foto]'),
      titulo: painel.querySelector('[data-titulo]'),
      sub: painel.querySelector('[data-sub]'),
      wasRotulo: painel.querySelector('[data-was-rotulo]'),
      was: painel.querySelector('[data-was]'),
      nowRotulo: painel.querySelector('[data-now-rotulo]'),
      now: painel.querySelector('[data-now]'),
      varianteRotulo: painel.querySelector('[data-variante-rotulo]'),
      select: painel.querySelector('[data-select]'),
      recusar: painel.querySelector('[data-recusar]'),
      aceitar: painel.querySelector('[data-aceitar]'),
      bandeiras: painel.querySelector('[data-bandeiras]'),
      fechar: painel.querySelector('.aura-upsell__fechar')
    };

    disponiveis.forEach(function (v) {
      var o = document.createElement('option');
      o.value = String(v.id);
      o.textContent = v.titulo;
      refs.select.appendChild(o);
    });

    refs.nota.textContent = cfg.textos.avaliacao || '';
    refs.timerRotulo.textContent = cfg.textos.rotuloTimer || '';
    refs.titulo.textContent = cfg.produto.titulo;
    refs.varianteRotulo.textContent = cfg.textos.rotuloVariante || '';
    refs.aceitar.textContent = cfg.textos.aceitar || 'Add to order';
    refs.recusar.textContent = cfg.textos.recusar || 'Decline this offer';
    refs.wasRotulo.textContent = cfg.textos.was || 'WAS';
    refs.nowRotulo.textContent = cfg.textos.now || 'NOW';

    if (cfg.mostrarBandeiras && cfg.bandeiras && cfg.bandeiras.length) {
      refs.bandeiras.innerHTML = cfg.bandeiras.join('');
    } else {
      refs.bandeiras.remove();
    }

    refs.select.addEventListener('change', pintar);
    refs.fechar.addEventListener('click', function () {
      fechar();
      seguir();
    });
    refs.recusar.addEventListener('click', function () {
      fechar();
      seguir();
    });
    refs.aceitar.addEventListener('click', aceitar);
    raiz.addEventListener('click', function (e) {
      if (e.target === raiz) {
        fechar();
        seguir();
      }
    });

    pintar();
    return true;
  }

  function pintar() {
    var v = variantePorId(refs.select.value) || variantesValidas()[0];
    if (!v) return;

    refs.chamada.textContent = trocarFicha(cfg.textos.titulo, v);

    var sub = trocarFicha(cfg.textos.subtexto, v);
    refs.sub.innerHTML = '';
    refs.sub.appendChild(document.createTextNode(sub + ' '));
    if (cfg.textos.escolha) {
      var forte = document.createElement('strong');
      forte.textContent = cfg.textos.escolha;
      refs.sub.appendChild(forte);
    }

    refs.foto.src = v.imagem || cfg.produto.imagem;
    refs.foto.alt = cfg.produto.titulo;
    refs.now.textContent = dinheiro(v.preco);

    if (v.tabela > v.preco) {
      refs.was.textContent = dinheiro(v.tabela);
      refs.was.parentNode.style.display = '';
    } else {
      refs.was.textContent = '';
    }
  }

  /* ------------------------------------------------------------- contador */

  function tocarRelogio() {
    var restam = cfg.segundos || 300;

    function pintarTempo() {
      var m = Math.floor(restam / 60);
      var s = restam % 60;
      refs.timer.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    }

    pintarTempo();
    clearInterval(relogio);
    relogio = setInterval(function () {
      restam--;
      if (restam <= 0) {
        restam = 0;
        clearInterval(relogio);
      }
      pintarTempo();
    }, 1000);
  }

  /* --------------------------------------------------------------- fluxo */

  function abrir() {
    if (!raiz && !montar()) return false;
    raiz.classList.add('is-open');
    document.body.classList.add('aura-upsell-aberto');
    tocarRelogio();
    return true;
  }

  function fechar() {
    if (!raiz) return;
    raiz.classList.remove('is-open');
    document.body.classList.remove('aura-upsell-aberto');
    clearInterval(relogio);
  }

  function seguir() {
    if (seguindo) return;
    seguindo = true;
    window.location.href = cfg.rotas.checkout;
  }

  function aceitar() {
    var v = variantePorId(refs.select.value) || variantesValidas()[0];
    if (!v) {
      fechar();
      seguir();
      return;
    }

    refs.aceitar.disabled = true;
    fetch(cfg.rotas.add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
    })
      .then(function () {
        fechar();
        seguir();
      })
      .catch(function () {
        // nao conseguiu adicionar: o cliente segue pro checkout do mesmo jeito
        fechar();
        seguir();
      });
  }

  /* ---------------------------------------------------------- intercepcao */

  function deveInterceptar() {
    if (!cfg || jaMostrou || seguindo) return false;
    if (!variantesValidas().length) return false;
    if (cfg.umaVezPorSessao) {
      try {
        if (sessionStorage.getItem(cfg.chaveSessao) === '1') return false;
      } catch (e) {
        // sessao indisponivel (aba anonima, cookies bloqueados): segue mostrando
      }
    }
    return true;
  }

  function marcarVisto() {
    jaMostrou = true;
    if (!cfg.umaVezPorSessao) return;
    try {
      sessionStorage.setItem(cfg.chaveSessao, '1');
    } catch (e) {
      /* sem sessao, sem marca */
    }
  }

  function ehBotaoDeCheckout(alvo) {
    if (!alvo || !alvo.closest) return null;
    var botao = alvo.closest('button[name="checkout"], input[type="submit"][name="checkout"], .cart__checkout-button');
    if (!botao) return null;
    var form = botao.form || botao.closest('form');
    if (!form) return null;
    var id = form.id || '';
    if (id !== 'CartDrawer-Form' && id !== 'cart' && id !== 'CartForm') return null;
    return botao;
  }

  function interceptar(e) {
    if (!ehBotaoDeCheckout(e.target)) return;
    if (!deveInterceptar()) return;

    if (!abrir()) return; // nao conseguiu abrir: deixa o tema seguir

    e.preventDefault();
    e.stopImmediatePropagation();
    marcarVisto();
  }

  function iniciar() {
    cfg = lerConfig();
    if (!cfg || !cfg.produto || !cfg.produto.variantes) return;

    document.addEventListener('click', interceptar, true);
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.id) return;
        if (form.id !== 'CartDrawer-Form' && form.id !== 'cart' && form.id !== 'CartForm') return;
        var enviador = e.submitter || document.activeElement;
        if (enviador && enviador.name && enviador.name !== 'checkout') return;
        if (!deveInterceptar()) return;
        if (!abrir()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        marcarVisto();
      },
      true
    );

    // voltar do checkout pelo botao do navegador: o painel nao pode reaparecer
    window.addEventListener('pageshow', function () {
      seguindo = false;
      fechar();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
